import {ProgramState} from "../types/ProgramState";
import Vue from 'vue';

export const state: ProgramState = {
    programs: Vue.observable({}),
    savedMeeting: null,
    currentDate: null,
    useRealtimeUpdates: true
}